(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.config = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports["default"] = void 0;
  var _default = {
    "LOGIN_URL": "https://permission.1sapp.com",
    "PROJECT_SCHEMA": "ewx-project",
    "TOKEN_SCHEMA": "ewx-perm-token",
    "QA_SCHEMA": "ewx-qa",
    "TOKEN_EXPIRES": 100,
    "API_URL": "https://api-perm.1sapp.com",
    "TEST_API_URL": "http://test-api.qukan.perm.qttcs3.cn" // "TEST_API_URL": "http://perm-api.qttcs3.cn"

  };
  _exports["default"] = _default;
});


//////////////////
// WEBPACK FOOTER
// ./~/@qtt/ewx-login-sdk/lib/config.js
// module id = 261
// module chunks = 24